import { useMemo } from 'react';
import { useAppSelector } from '@common/store';
import { useAllFeatureFlags } from '@common/store/reducers/featureFlags';
import { getAccessRights } from '@common/utils/accessRights';

const useAccessRights = () => {
  const { featureFlags } = useAllFeatureFlags();
  const currentUser = useAppSelector((state) => state.main.user);
  const rights = useMemo(
    () => getAccessRights(currentUser, featureFlags, APP_TYPE),
    [currentUser, featureFlags],
  );

  return { currentUser, ...rights };
};

export default useAccessRights;
